export const ADD_LEAD_IMPLANT = 'ADD_LEAD_IMPLANT'
export const ADD_LEAD_IMPLANT_SUCCESS = 'ADD_LEAD_IMPLANT_SUCCESS'
export const ADD_LEAD_IMPLANT_FAILED = 'ADD_LEAD_IMPLANT_FAILED'

export const UPDATE_LEAD_IMPLANT = 'UPDATE_LEAD_IMPLANT'
export const UPDATE_LEAD_IMPLANT_SUCCESS = 'UPDATE_LEAD_IMPLANT_SUCCESS'
export const UPDATE_LEAD_IMPLANT_FAILED = 'UPDATE_LEAD_IMPLANT_FAILED'

export const DELETE_LEAD_IMPLANT = 'DELETE_LEAD_IMPLANT'
export const DELETE_LEAD_IMPLANT_SUCCESS = 'DELETE_LEAD_IMPLANT_SUCCESS'
export const DELETE_LEAD_IMPLANT_FAILED = 'DELETE_LEAD_IMPLANT_FAILED'
